import Vue from 'vue';

import 'core-js';
import './js/bootstrap';

import App from './App';
import store from './store';
import router from './router';
import oidc from './vue-oidc-client';
import VAppErrorOverlay from './views/components/VAppErrorOverlay/VAppErrorOverlay.vue';
import { APP_ERROR_KIND, showAppError } from './js/appError';
import { restoreCachedTextSize } from './js/textSize';

Vue.config.productionTip = false;

// Размер текста — до первой отрисовки: стили уже загружены, а #app ещё пуст, поэтому
// экран сразу появляется в выбранном размере, без видимого перескока.
restoreCachedTextSize();

oidc.startup().then((ok) => {
    if (ok) {
        new Vue({
            store,
            router,
            render: (h) => h(App),
        }).$mount('#app');
    } else {
        // OIDC не поднялся — приложение смонтировать не из чего (ни стора, ни маршрутов).
        // Показываем тот же экран ошибки отдельным корнем: раньше здесь висел английский
        // «Something went wrong...» без единого действия.
        showAppError(APP_ERROR_KIND.AUTH, { closable: false });

        new Vue({
            render: (h) => h(VAppErrorOverlay),
        }).$mount('#app');
    }
});
